// Test DeepSeek API Connection
class ApiConnectionTest {
  constructor() {
    this.apiKey = 'sk-7549b29d010a424a836d081a478552f4';
    this.baseUrl = 'https://api.deepseek.com';
  }

  async testConnection() {
    try {
      if (!this.apiKey) {
        return {
          success: false,
          error: 'API key not configured'
        };
      }

      const response = await fetch(`${this.baseUrl}/chat/completions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.apiKey}`
        },
        body: JSON.stringify({
          model: 'deepseek-chat',
          messages: [
            {
              role: 'user',
              content: 'Hello, please respond with "API connection successful"'
            }
          ],
          max_tokens: 50,
          temperature: 0.1
        })
      });

      if (!response.ok) {
        throw new Error(`API request failed: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      
      return {
        success: true,
        message: 'API connection successful',
        response: data.choices[0].message.content
      };

    } catch (error) {
      console.error('API Connection Test Error:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
}

const apiConnectionTest = new ApiConnectionTest();
export default apiConnectionTest; 